const navigation = 1030;
const modalBase = 1040;
const sidebar = 6;
const tableHeaderCell = 100;
const zIndices = {
  sidebar,
  sidebarContentColumn: sidebar + 1,
  sidebarOverlay: sidebar - 1,
  tableHeaderCell,
  tableHeaderCellPinned: tableHeaderCell + 100,
  expandButton: 10,
  resizeHandle: 100,
  navigationDropdown: navigation + 2,
  modalOverlay: modalBase,
  modalBody: modalBase + 10,
  confirmModalOverlay: modalBase + 11,
  confirmModalBody: modalBase + 12,
  notifications: modalBase + 13,
  dropdownMenu: modalBase + 13,
  indicator: 2e3
};
export default zIndices;
